import { DraftErrorReason } from "../store/common/aiCopilot";

export const getDraftErrorReason = (status: number): DraftErrorReason => {
  switch (status) {
    case 400:
      return 'invalid';
    case 403:
      return 'forbidden';
    case 409:
      return 'superseded';
    case 410:
      return 'expired';
    default:
      return 'unavailable';
  }
};
